import * as React from "react";
import {getTranslation} from "../../utils/translationUtil";

export const HomeHeader: React.FunctionComponent = () => {
    return <section className="home-header__welcome-section" data-testid="home-header__container">
        <div className="home-header__welcome-inner">
            <h1 className="home-header__welcome-title">
                {getTranslation("home.welcome-title", "Welcome to Iris")}
            </h1>
            <p className="home-header__welcome-description">
                {getTranslation("home.welcome-description", "Your gateway to advanced, data-driven investment insights.")}
            </p>
        </div>
    </section>;
};